import { z } from "zod";

export const companyStatusSchema = z.object({
  status: z.number()
})

export type CompanyStatus = z.infer<typeof companyStatusSchema>;